<script>
  import { createEventDispatcher } from 'svelte'

  const dispatch = createEventDispatcher()

  export let name
  export let isActive

  let id = `tab-${name}`
</script>

<button
  {id}
  role="tab"
  tabindex={isActive ? '0' : '-1'}
  aria-selected={isActive ? 'true' : null}
  on:click
  on:keyup
>
  <slot />
</button>
